// data source: https://github.com/modood/Administrative-divisions-of-China
import PCCodeRaw from './data/pc-code.json';
const PCCode = PCCodeRaw;
export const AdminDivisionsOfChina = {
    getProvinces() {
        return PCCode.map((province) => ({ code: province[0], name: province[1] }));
    },
    getCities() {
        return PCCode.map((province) => province[2])
            .reduce((result, cities) => result.concat(cities), [])
            .map((city) => ({ code: city[0], name: city[1] }));
    },
    getProvinceCities(provinceCode) {
        const province = PCCode.find((element) => element[0] === provinceCode);
        if (province === undefined)
            throw new Error('province code is not found in provinces');
        return (province[2]).map((city) => ({ code: city[0], name: city[1] }));
    },
    getCityInProvince(cityCode) {
        const province = PCCode.find((element) => {
            return (element[2]).some((city) => city[0] === cityCode);
        });
        if (province === undefined)
            throw new Error('city code is not found in provinces children');
        return { code: province[0], name: province[1], children: province[2].map((el) => ({ code: el[0], name: el[1] })) };
    }
};
//# sourceMappingURL=index.js.map